import { isNil } from 'lodash';
import { IPageData } from '../../../types/rest/IPageData';
import { useMemo } from 'react';
import { BootstrapSortDirection } from 'react-bootstrap-table-next';

//ReactBootstrapTableNext uses 1 index. Spring uses 0.
export const convertQueryPageNumberToTablePageNumber = (page?: number) => {
  if (isNil(page)) return 1;
  return page + 1;
};

interface BootstrapTableNextPagination {
  page: number;
  sizePerPage: number;
  totalSize: number;
}

export function useDeterminePagination<T>({
  pageNumber,
  pageSize,
  totalElements,
}: IPageData<T>): BootstrapTableNextPagination {
  return useMemo(() => {
    return {
      page: convertQueryPageNumberToTablePageNumber(pageNumber),
      sizePerPage: pageSize ?? 20,
      totalSize: totalElements,
    };
  }, [pageNumber, pageSize, totalElements]);
}

export const convertTableSortToQuerySortBy = (
  tableSortField?: string,
  tableSortOrder?: BootstrapSortDirection,
  sortConversionMethod?: (tableSortField?: string) => string
): string => {
  if (sortConversionMethod) {
    return `${sortConversionMethod(tableSortField)}.${tableSortOrder ?? 'desc'}`;
  }
  return `${tableSortField}.${tableSortOrder ?? 'desc'}`;
};
